module.exports = __webpack_public_path__ + "static/media/epay.6276ea3c.png";